import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { UserMenu } from './UserMenu';
import { useAuthContext } from '../../../contexts/AuthContext';

interface NavigationProps {
  onItemClick?: () => void;
}

export function Navigation({ onItemClick }: NavigationProps) {
  const { user } = useAuthContext();
  const location = useLocation();
  const navigate = useNavigate();

  const handleListService = () => {
    navigate('/signup');
    onItemClick?.();
  };

  const handleNavClick = (callback?: () => void) => {
    callback?.();
    onItemClick?.();
  };

  if (user) {
    return (
      <div className="flex flex-col lg:flex-row items-stretch lg:items-center gap-4 lg:gap-6 w-full lg:w-auto">
        {/* Track Aircraft Link */}
        <Link 
          to="/tracking" 
          onClick={() => handleNavClick()}
          className={`
            block px-4 py-3 lg:py-2 rounded-lg lg:rounded-xl text-sm font-medium transition-all duration-200 text-center w-full lg:w-auto
            ${location.pathname === '/tracking' 
              ? 'text-white bg-white/20 shadow-lg' 
              : 'text-white/80 hover:text-white hover:bg-white/10'
            }
          `}
        >
          Track Aircraft
        </Link>
        
        {/* User Menu */}
        <div className="w-full lg:w-auto">
          <UserMenu onItemClick={onItemClick} />
        </div>
      </div>
    );
  }

  // Non-authenticated navigation
  const navItems = [
    { to: '/tracking', name: 'Track Aircraft' },
    { to: '/pricing', name: 'Pricing' },
    { to: '/signin', name: 'Sign In' }
  ];

  return (
    <nav className="flex flex-col lg:flex-row items-stretch lg:items-center gap-3 lg:gap-6 w-full lg:w-auto">
      {navItems.map((item) => (
        <Link 
          key={item.to}
          to={item.to}
          onClick={() => handleNavClick()}
          className={`
            block px-4 py-3 lg:py-2 rounded-lg lg:rounded-xl text-sm font-medium transition-all duration-200 text-center w-full lg:w-auto
            ${location.pathname === item.to 
              ? 'text-white bg-white/20 shadow-lg' 
              : 'text-white/80 hover:text-white hover:bg-white/10'
            }
          `}
        >
          {item.name}
        </Link>
      ))}
      
      <button
        onClick={handleListService}
        className="group relative px-4 lg:px-6 py-3 lg:py-2.5 mt-2 lg:mt-0 lg:ml-2 overflow-hidden rounded-lg lg:rounded-xl font-semibold text-white transition-all duration-300 hover:scale-105 w-full lg:w-auto"
      >
        <div className="absolute inset-0 bg-gradient-to-r from-primary-500 to-blue-600 transition-all duration-300 group-hover:from-primary-400 group-hover:to-blue-500"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-white/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
        <span className="relative z-10 text-sm">List Your Service</span>
      </button>
    </nav>
  );
}